import React from "react";
import "../../App.css";
import CompilerError from "../CompilerError";
import Problem from "../Problem";
import Suggestion from "../Suggestion";
import BadExample from "../BadExample";
import GoodExample from "../GoodExample";
import { makeClassStubIfUnknown, isKnownType, makeDemoValue } from "../../demoValues";

class UnexpectedToken extends React.Component {

  render() {
    const intTypes = ["int", "short", "byte", "long", "char"];
    const demoValue = makeDemoValue(this.props.typeName);

    const classPlaceholder = <div className="Indent-0">{makeClassStubIfUnknown(this.props.typeName)}</div>;

    return <CompilerError
      title={<>unexpected token: <div className="InputValue">{this.props.typeName}</div></>}
      translation={<>There is something incorrect concerning the <div className="InputValue">{this.props.typeName}</div>{" "}
        variable you are trying to use.</>}
      embed={this.props.embed} 
      fontSize={this.props.fontSize}
    >
      {isKnownType(this.props.typeName)
        ? <><Problem id={1} 
          title="You may have forgotten to place a semicolon at the end of your current line."
        >
          <Suggestion title={"Add a \";\" to the end of the line."} id={1}>
            <BadExample>
              <div className="Indent-0">{this.props.typeName} s = {demoValue}</div>
            </BadExample>
            <GoodExample>
              <div className="Indent-0">{this.props.typeName} s = {demoValue};</div>
            </GoodExample>
          </Suggestion>
        </Problem>
          <Problem id={2}
            title="You may have left a variable without declaring it."
          >
            <Suggestion title="Either declare the variable, assign it, or just remove it if it is not used." id={2}>
              <BadExample>
                <div className="Indent-0"> s; </div>
              </BadExample>
              <GoodExample>
                <div className="Indent-0"> {this.props.typeName} s; </div>
              </GoodExample>
              <GoodExample>
                <div className="Indent-0"> {this.props.typeName} s = {demoValue}; </div>
              </GoodExample>
              <GoodExample>
                <div className="Indent-0"> <del>s;</del> </div>
              </GoodExample>
            </Suggestion>
          </Problem></>
        : <Problem id={3}
          title="You may have left an object without declaring it."
        >
          <Suggestion title="Either declare the object, assign it, or just remove it if it is not used." id={3}>
            <BadExample>
              {classPlaceholder}
              <div className="Indent-0"> {this.props.typeName} </div>
            </BadExample>
            <GoodExample>
              {classPlaceholder}
              <div className="Indent-0"> {this.props.typeName} s; </div>
            </GoodExample>
            <GoodExample>
              {classPlaceholder}
              <div className="Indent-0"> {this.props.typeName} s = {demoValue}; </div>
            </GoodExample>
            <GoodExample>
              {classPlaceholder}
              <div className="Indent-0"> <del> {this.props.typeName} </del> </div>
            </GoodExample>
          </Suggestion>
        </Problem>
      }
      {intTypes.includes(this.props.typeName)
        ? <Problem id={4}
          title={<>You may have incorrectly tried to cast a <div className="InputValue"></div> float {" "}
            variable onto a <div className="InputValue">{this.props.typeName}</div> variable.</>}
        >
          <Suggestion id={4} title={<>Add a parentheses around <div className="InputValue">{this.props.typeName}</div>, {" "}
            the type you are trying to convert the variable to.</>}>
            <BadExample>
              <div className="Indent-0"> float f = 5.5; </div>
              <div className="Indent-0"> {this.props.typeName} s = {this.props.typeName} f; </div>
            </BadExample>
            <GoodExample>
              <div className="Indent-0"> float f = 5.5; </div>
              <div className="Indent-0"> {this.props.typeName} s = ({this.props.typeName}) f; </div>
            </GoodExample>
          </Suggestion>
        </Problem>
        : <></>
      }
      {this.props.typeName === 'int'
        ? <Problem id={5}
          title="You may have incorrectly written the parameter of control structures (if-else statement, for-loop, etc.)."
        >
          <Suggestion title="Change the parameters of the control structure." id={5}>
            <BadExample>
              <div className="Indent-0"> {this.props.typeName} s = 5; </div>
              <div className="Indent-0"> if ({this.props.typeName} i = 0; i {" < "} 10; i++) {"{"} </div>
              <div className="Indent-1"> s += s; </div>
              <div className="Indent-0"> {"}"} </div>
            </BadExample>
            <GoodExample>
              <div className="Indent-0"> {this.props.typeName} s = 5; </div>
              <div className="Indent-0"> if (s {"<"} 10) {"{"} </div>
              <div className="Indent-1"> s += s; </div>
              <div className="Indent-0"> {"}"} </div>
            </GoodExample>
          </Suggestion>
          <Suggestion title="Change the control structure itself." id={6}>
            <BadExample>
              <div className="Indent-0"> {this.props.typeName} s = 5; </div>
              <div className="Indent-0"> if ({this.props.typeName} i = 0; i {" < "} 10; i++) {"{"} </div>
              <div className="Indent-1"> s += s; </div>
              <div className="Indent-0"> {"}"} </div>
            </BadExample>
            <GoodExample>
              <div className="Indent-0"> {this.props.typeName} s = 5; </div>
              <div className="Indent-0"> for ({this.props.typeName} i = 0; i {" < "} 10; i++) {"{"} </div>
              <div className="Indent-1"> s += s; </div>
              <div className="Indent-0"> {"}"} </div>
            </GoodExample>
          </Suggestion>
        </Problem>
        : <></>
      }
    </CompilerError>;
  }

}

export default UnexpectedToken;